import { BenefForVentesModeleDto } from 'src/graphql/generated-types';

const stateName = '[Sales] ';

export class GetBenefModelForVentesClientAction {
    static readonly type = stateName + 'GetBenefModelForVentesClient';

    constructor(public idBeneficiary: number, public orderId: number) {
    }
}

export class GetMontantFactImpayeeBenefAction {
    static readonly type = stateName + 'GetMontantFactImpayeeBenef';
}

export class GetImpayesAvoirsAcomptesAction {
    static readonly type = stateName + 'GetImpayesAvoirsAcomptes';
}

export class GetNbLivraisonsEnAttenteAction {
    static readonly type = stateName + 'GetNbLivraisonsEnAttente';

    constructor(public activityId: number) {
    }
}

export class ActivitySetBeneficiaryAction {
    static readonly type = stateName + 'ActivitySetBeneficiary';

    constructor(public beneficiary: BenefForVentesModeleDto) {
    }
}

export class ResetActivityBeneficiaryStateAction {
    static readonly type = stateName + 'ResetActivityBeneficiaryState';
}

